<template>
<div>
    <el-dialog :visible.sync="passwordManager.formVisibility" title="Enter the password to join the room" :before-close="cancelPasswordFormVisible" :modal-append-to-body="false">
        <el-form @submit.prevent.native="validatePassword" :model="passwordManager">
            <el-row>
                <el-input placeholder="Enter password" v-model="passwordManager.password"></el-input>
            </el-row>
        </el-form>
        <p class="password-incorrect">
            <span v-if="passwordManager.isPasswordIncorrect">Invalid password</span>
        </p>
        <span slot="footer" >
            <el-button size="small" @click="cancelPasswordFormVisible">Cancel</el-button>
            <el-button size="small" type="primary" @click="validatePassword">Confirm</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    name: "Password",
    props: ['room', 'onSuccess', 'onFailure'],
    data: function () {
        return {
            passwordManager: {
                formVisibility: true,
                isPasswordIncorrect: false,
                password: ''
            }
        }
    },

    methods: {
        cancelPasswordFormVisible() {
            this.passwordManager.formVisibility = false;
            this.passwordManager.password = '';
            this.onFailure();
        },

        isPasswordValid: function () {
            return !this.room.password || this.room.password === this.passwordManager.password ? true : false;
        },

        validatePassword: function () {
            const isPasswordValid = this.isPasswordValid();
            this.passwordManager.isPasswordIncorrect = !isPasswordValid;
            this.passwordManager.formVisibility = !isPasswordValid;
            this.passwordManager.password = '';
            isPasswordValid ? this.onSuccess() : undefined;            
        }
    }
}
</script>

<style scoped>
>>> .el-dialog{
    width: 100%;
    max-width: 360px;
}
>>> .el-dialog__footer{
    margin-top: -10px !important;
}
>>>div.el-dialog__header,
>>>div.el-dialog__body,
>>>div.el-dialog__footer{
    background: #2A2A3D;
}
>>>span.el-dialog__title {
    color: #E7E6FA;
}
>>>button.el-button--default,
>>>button.el-button--default:hover {
    border: 1px solid #E7E6FA;
    background: #2A2A3D;
    color: #E7E6FA;
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    height: 36px;
}

>>>button.el-button--primary,
>>>button.el-button--primary:hover {
    border: 1px solid #6F26DF;
    background: #6F26DF;
    color: #E7E6FA;
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    height: 36px;
}

>>>input.el-input__inner,
>>>.el-input.is-disabled .el-input__inner {
    background: #393752;
    border-radius: 3px;
    height: 32px;
    border: none;
    color: #E7E6FA;
}

>>>.el-input .el-input__inner{
    color: #E7E6FA;
}
>>>.el-input .el-input__inner::-webkit-input-placeholder { /* Edge */
    color: rgba(231, 230, 250, 0.4);
}

>>>.el-input .el-input__inner:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(231, 230, 250, 0.4);
}

>>>.el-input .el-input__inner::placeholder {
    color: rgba(231, 230, 250, 0.4);
}

.password-incorrect{
    margin: 0px !important;
    color: #E05A5A;
    text-align: left;
    padding: 10px 0;
}
    
</style>
